export const GET_PROFILE_REQUIRED_FIELD = "profile/GET_PROFILE_REQUIRED_FIELD";
export const SET_PROFILE_REQUIRED_FIELD = "profile/SET_PROFILE_REQUIRED_FIELD";;
export const FETCH_PROFILE_REQUIRED_FIELD = "profile/FETCH_PROFILE_REQUIRED_FIELD";
;

export const getRequiredFiled = (data) => {
  return {
    type: GET_PROFILE_REQUIRED_FIELD,
    payload: data,
  };
};
export const fetchRequiredFiled = (data) => {
  return {
    type: FETCH_PROFILE_REQUIRED_FIELD,
    payload: data,
  };
};
export const setRequiredField = (data) => {
  return {
    type: SET_PROFILE_REQUIRED_FIELD,
    payload: data,
  };
};
